import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { SharedService } from '../../../shared/services/shared.service';
import { Document } from '../../../models/mat-account.model';
import { MatDialogCloseEvent } from '../../../const';
import { MatAccountService } from '../mat-account.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmComponent } from '../../../shared/components/confirm/confirm.component';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent implements OnInit {  
  
  toggleButton: boolean = false;
  subscription: Subscription = new Subscription();
  uploadedFiles: File[] = [];
  uploadedDocuments: Document[] = [];
  hideUpload: boolean = false;  
  constructor(@Optional() public dialogRef: MatDialogRef<ConfirmDialogComponent>,
              private sharedService: SharedService,
              private matAccountService: MatAccountService,
              private toasterService: ToastrService,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.hideUpload = this.data.hideUpload;
    if(this.hideUpload){
      this.uploadedDocuments = this.data.files;
    }
    else{
      this.subscription.add(this.sharedService.uploadedFile.subscribe((data) => {
        this.uploadedFiles = data;
      }))
    }
    this.subscription.add(this.sharedService.isUploading.subscribe((data) => {
        this.toggleButton = data;
      }
    ));
  }
  onCancel(): void {
    this.dialogRef.close({event:MatDialogCloseEvent.CANCELLED});
  }

  removeItem(index: number) {
    this.uploadedFiles.splice(index, 1);
    this.sharedService.setUploadedFile(this.uploadedFiles);
  }

  removeFile(documentId: number) {
    this.dialog.open(ConfirmComponent, {
      width: '375px',
      data: {
        status: true,
        message: "Are you sure want to remove the document?"
      }
    }).afterClosed().subscribe((popupEvent: any)=>{
      if (popupEvent?.event == MatDialogCloseEvent.SUCCESS) {
        this.matAccountService.removeUploadedDocument(documentId.toString()).subscribe({
          next: (response) => {
            if(response){
              this.uploadedDocuments = this.uploadedDocuments.filter(doc => doc.documentId !== documentId);
              this.toasterService.success("Document Removed successfully", "Success");
              this.dialogRef.close({event:MatDialogCloseEvent.SUCCESS, doc: this.uploadedDocuments} );
            }
          },
          error: (error) => {
            console.error('Error Removing document', error);
          }
        });
      }
    });
  }

  onUpload(event:Event): void {
    this.sharedService.performFileUpload(this.data.isParentUpload);
  }

  previewFile(uploadedFiles: any): void {
    this.sharedService.previewFile(uploadedFiles);
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
